import { THEME } from '../../../../constants';
import { getChartFontColor, getChartGridColor } from '../../../../utils/chart';
import createInfoboxMarkup from '../../../infobox/createInfoboxMarkup';

const getPolarAreaConfig = (domains, theme = THEME.DARK) => {
  const fontColor = getChartFontColor(theme);
  const gridColor = getChartGridColor(theme);

  return {
    series: domains.map((item) => item.y),
    options: {
      labels: domains.map((item) => item.x),
      colors: domains.map((item) => item.color),
      chart: {
        type: 'polarArea',
      },
      stroke: {
        show: false,
      },
      fill: {
        opacity: 0.9,
      },
      yaxis: {
        labels: {
          style: {
            colors: fontColor,
            fontSize: '12px',
            fontWeight: 'normal',
            fontFamily: 'Inter',
          },
          formatter: (value) => value,
        },
      },
      legend: {
        show: false,
      },
      tooltip: {
        fillSeriesColor: false,
        theme: false,
        style: {
          dropShadow: {
            enabled: false,
          },
        },
        custom: function ({ series, seriesIndex }) {
          const domain = domains[seriesIndex];
          const score = series[seriesIndex];
          const records = [{ name: 'Score', value: score }];

          const tooltipTitle = domain.x;
          const tooltipSubtitle = domain.companyName ? domain.domain : '';

          return createInfoboxMarkup({
            title: tooltipTitle,
            subTitle: tooltipSubtitle,
            marker: { color: domains[seriesIndex].color },
            records,
          });
        },
      },
      plotOptions: {
        polarArea: {
          rings: {
            strokeWidth: 1,
            strokeColor: gridColor,
          },
          spokes: {
            strokeWidth: 1,
            connectorColors: gridColor,
          },
        },
      },
    },
  };
};

export default getPolarAreaConfig;
